import React from 'react';

import styled from 'styled-components';

import api from 'api';

import AnimateIn from 'partials/AnimateIn';
import Container from 'partials/Container';

export default props => {
    const author = props.data;
    const page = props.page;

    return(
        <ModuleWrapper>
            <AnimateIn>
                <Container flex wrap >
                     <Main>
                        { author && 
                            <AuthorWrapper>
                                <img className="image" src={author.image.url} />
                                <div className="author-content">
                                    <div className="name">{author.author_name}</div>
                                    <div className="publication">{page.date}</div>
                                </div>
                            </AuthorWrapper>
                        }
                     </Main>
                </Container>
            </AnimateIn>
        </ModuleWrapper>
    )
}


const ModuleWrapper = styled.article`
    margin-bottom:60px;
    @media (max-width: 768px) {
        margin-bottom:40px;
    }
`

const Sidebar = styled.div`
    width:40%;
    padding-right:20px;
    @media(max-width: 767px) {
        width:100%;
        padding-right: 0;
        display: flex;
        order: 2;
    }
`

const Main = styled.div`
    width:100%;
    
    ${props => props.pageBackground === 'main' ? `
        .html-content * {
            color: white;
        }
    ` : ``}

    ${props => props.sidebar ? `
        width: 60%; 
        padding-left: 20px;
        @media(max-width: 767px) {
            width:100%;
            padding-left: 0;
            display: flex;
            order: 1;
        }
    ` : ``}
`

const AuthorWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    .image {
        height: 45px;
        width: 45px;
        border-radius: 50%;
        float: left;
    }

    .author-content {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;

        .name {
            font-family: Helvetica;
            font-size: 16px;
            color: #002857;
            line-height: 24px;
            text-decoration: underline;
            padding-left: 25px;
        }

        .publication { 
            padding-left: 25px;
        }
    }
`;


// WEBPACK FOOTER //
// ./src/partials/modules/Author.js